import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class FileUploadService {


	constructor(private http: HttpClient) { }

	url = environment.serverAPI + "/api/core";


	uploadFile(data: FormData, assetId: number): Observable<Object> {
		return this.http.post(`${this.url}/upload?astid=${assetId}`, data);
	}

	uploadFiles(data: FormData, assetId: number): Observable<Object> {
		return this.http.post(`${this.url}/uploadMultipleFiles?astid=${assetId}`, data);
	}

	uploadPropertyFiles(data: FormData, assetId: number): Observable<Object> {
		return this.http.post(`${this.url}/uploadMultiplePropertyFiles?astid=${assetId}`, data);
	}


	categoryUpload(data: FormData): Observable<Object> {
		return this.http.post(`${this.url}/upload/category`, data);
	}

  normalUploadFile(data: FormData, type: any,location:any): Observable<Object> {
		return this.http.post(`${this.url}/normal/upload?type=${type}&location=${location}`, data);
	}

  normalUploadFiles(data: FormData, type: any,location:any): Observable<Object> {
		return this.http.post(`${this.url}/normal/uploadMultipleFiles?type=${type}&location=${location}`, data);
	}
}

